var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconQuizSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconQuiz",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "m1647.608 931.313-2.665 707.614-236.558 236.68h-.121l-352.475-352.476 591.819-591.818ZM792.79 1438.707l85.635 85.757-264.295 264.174-85.636-85.635 264.296-264.296Zm-176.165-176.044 85.636 85.636-352.354 352.233-85.636-85.636 352.354-352.233Zm-176.092-176.249 85.514 85.757-440.411 440.29L0 1526.947l440.533-440.533ZM1033.44 317.28 441.744 908.977 89.27 556.745l236.68-236.679 707.492-2.786Zm597.548-41.17 55.96 2.059 2.301 56.08c2.302 54.992-13.323 138.932-100.897 226.384l-42.757 42.878-184.11-184.231 42.756-42.879c86.605-86.483 172.24-102.108 226.747-100.291Zm259.45-202.037c-73.28-27.617-341.21-101.382-615.558 172.967L570.173 951.747l221.417 221.538 221.418 221.417 704.707-704.828c273.016-273.017 199.857-543.005 172.725-615.801",
        fillRule: "evenodd"
      }))
    });
  }
}
IconQuizSolid.glyphName = 'quiz';
IconQuizSolid.variant = 'Solid';
IconQuizSolid.displayName = 'IconQuizSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconQuizSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconQuizSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconQuizSolid;
export { IconQuizSolid };